import config from './businessConfig.cjs';
export const { SITE_URL, business, businessSchema, websiteSchema, businessReference, serializeSchema } = config;